import { render, staticRenderFns } from "./ExtendAuctionAction.vue?vue&type=template&id=315a1bce&scoped=true&"
import script from "./ExtendAuctionAction.vue?vue&type=script&lang=ts&"
export * from "./ExtendAuctionAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a1bce",
  null
  
)

export default component.exports